<h2 mat-dialog-title class="bg-blue text-white">Administrator Settings</h2>
<mat-dialog-content>
  <p *ngIf="isNew && !isMe">
    Use the form below to fill out the information for the new administrator and toggle the settings available.
  </p>
  <p *ngIf="!isNew && !isMe">
    Use the form below to update the information for {{ administrator.firstName }}
    {{ administrator.lastName }} ({{ administrator.emailAddress }}).
  </p>
  <p *ngIf="isMe">
    Use the form below to update your information.
  </p>
  <form [formGroup]="form" class="app-form">
    <fieldset [formGroup]="form.controls.contact">
      <legend>Contact Information</legend>
      <!-- Administrator First Name -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>First Name</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.contact.controls.firstName"
               [readonly]="formDisabled" placeholder="Jane">
        <mat-error *ngIf="form.controls.contact.controls.firstName?.hasError('required')">
          First Name is required.
        </mat-error>
      </mat-form-field>

      <!-- Administrator Last Name -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Last Name</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.contact.controls.lastName"
               [readonly]="formDisabled" placeholder="Doe">
        <mat-error *ngIf="form.controls.contact.controls.firstName?.hasError('required')">
          Last Name is required.
        </mat-error>
      </mat-form-field>
    </fieldset>

    <fieldset [formGroup]="form.controls.authentication">
      <legend>Authentication Details</legend>

      <!-- Administrator Email Address -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Email Address</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.authentication.controls.emailAddress"
               [readonly]="formDisabled" placeholder="jane.doe@domain.tld">
        <mat-error *ngIf="form.controls.authentication.controls.emailAddress?.hasError('required')">Email Address is
          required.
        </mat-error>
        <mat-error *ngIf="form.controls.authentication.controls.emailAddress?.hasError('email')">
          Invalid Email Address.
        </mat-error>
      </mat-form-field>

      <!-- Administrator Password -->
      <mat-form-field class="app-form-field-quarter" floatLabel="always">
        <mat-label>Password</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.authentication.controls.password"
               [readonly]="formDisabled" placeholder="s0m3SuPerS3cr3t!" type="password">
        <mat-error *ngIf="form.controls.authentication.controls.password?.hasError('required')">
          Password is required.
        </mat-error>
        <mat-error *ngIf="form.controls.authentication.controls.password?.hasError('passwordsMismatch')
          || form.controls.authentication.controls.passwordConfirmation?.hasError('passwordsMismatch')
          && !form.controls.authentication.controls.password?.hasError('required')">
          The Password and Password Confirmation do not match.
        </mat-error>
      </mat-form-field>

      <!-- Administrator Password Confirmation -->
      <mat-form-field class="app-form-field-quarter" floatLabel="always">
        <mat-label>Confirm Password</mat-label>
        <input matInput [disabled]="formDisabled"
               [formControl]="form.controls.authentication.controls.passwordConfirmation"
               [readonly]="formDisabled" placeholder="s0m3SuPerS3cr3t!" type="password">
        <mat-error *ngIf="form.controls.authentication.controls.passwordConfirmation?.hasError('required')">
          Password Confirmation is required.
        </mat-error>
        <mat-error *ngIf="form.controls.authentication.controls.passwordConfirmation?.hasError('passwordsMismatch')
          || form.controls.authentication.controls.password?.hasError('passwordsMismatch')
          && !form.controls.authentication.controls.passwordConfirmation?.hasError('required')">
          The Password and Password Confirmation do not match.
        </mat-error>
      </mat-form-field>
    </fieldset>

    <fieldset *ngIf="false" [formGroup]="form.controls.options">
      <legend>Settings</legend>

      <!-- Locked Flag -->
      <mat-slide-toggle class="app-form-field-third" [disabled]="formDisabled"
                        [formControl]="form.controls.options.controls.locked">Locked
      </mat-slide-toggle>

      <!-- Password Expires Flag -->
      <mat-slide-toggle class="app-form-field-third" [disabled]="formDisabled"
                        [formControl]="form.controls.options.controls.passwordExpires">Password Expires
      </mat-slide-toggle>

      <!-- Require Password Change Flag -->
      <mat-slide-toggle class="app-form-field-third" [disabled]="formDisabled"
                        [formControl]="form.controls.options.controls.passwordPromptForChange">Require Password Change
      </mat-slide-toggle>
    </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()" aria-label="Button to close the dialog."
          color="icon-slate"
          matTooltip="Close the dialog without saving changes." type="button">
    <mat-icon>close</mat-icon>
    Cancel
  </button>
  <button mat-button (click)="save()"
          [disabled]="formDisabled || !form.valid"
          aria-label="Button to save the administrator back to persistent storage."
          [color]="formDisabled || !form.valid ? 'icon-slate' : 'icon-green'"
          matTooltip="Save the administrator to persistent storage." type="button">
    <mat-icon>save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
